class ProductList extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-product-list-swiper]');
        this.swiper = null;
        this.swiperEl && this.constructSwiper();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            init: false,
            watchOverflow: true,
            slidesPerView: 2,
            spaceBetween: 10,
            loop: false,
            navigation: {
                nextEl: '[data-product-list-next]',
                prevEl: '[data-product-list-prev]',
            },
            autoplay: {
                delay: 7000,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 40
                },
            }
        });

        this.swiper.on('resize init', (instance) => {
            this.swiperEl.classList.toggle('slider-active', instance.virtualSize > instance.size);
        });

        this.swiper.init();
    }
}
